import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

const sizes = {
  xs: "h-3 w-3",
  sm: "h-4 w-4",
  md: "h-5 w-5",
  lg: "h-7 w-7",
  xl: "h-10 w-10",
} as const;

export interface SpinnerProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: keyof typeof sizes;
  label?: string;
}

/** Consistent app-wide async spinner. */
export function Spinner({ size = "sm", label, className, ...props }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-live="polite"
      aria-label={label ?? "Loading"}
      className={cn("inline-flex items-center gap-2 text-muted-foreground", className)}
      {...props}
    >
      <Loader2 className={cn("animate-spin text-primary", sizes[size])} />
      {label && <span className="text-sm">{label}</span>}
    </span>
  );
}

export default Spinner;
